export function formatSize(bytes: number): string {
  const k = 1024;
  const dm = 0;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

  if (bytes === 0) {
    return `0 ${sizes[0]}`;
  }

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

  return `${formattedSize} ${sizes[i]}`;
}

export function getFileIcon(fileName: string): string {
  const ext = fileName.split('.').pop()?.toLowerCase();
  const icons: Record<string, string> = {
    pdf: 'assets/images/document-red.svg',
    doc: 'assets/images/document-blue.svg',
    docx: 'assets/images/document-blue.svg',
    xls: 'assets/images/document-green.svg',
    xlsx: 'assets/images/document-green.svg',
  };
  return icons[ext || ''] || 'assets/images/document-blue.svg';
}

export function checkAcceptedFileType(fileInput: HTMLInputElement, file: File) {
  const acceptAttr = fileInput?.getAttribute('accept');
  let acceptedTypes: string[] = [];
  if (acceptAttr) {
    acceptedTypes = acceptAttr.split(',').map((type) => type.trim());
  }

  // Validate file type
  const isAcceptedType =
    acceptedTypes.length === 0 ||
    acceptedTypes.some((type) => {
      if (type.startsWith('.')) {
        return file.name.toLowerCase().endsWith(type.toLowerCase());
      }
      return file.type === type;
    });
  return isAcceptedType;
}
